import Vue from "vue";

const state = {
	appversion: null,
	headerspreference: JSON.parse(localStorage.getItem("headerspreference")) || {},
};

const getters = {
	getAppVersion: (state) => state.appversion,
	getHeadersPreference: (state) => state.headerspreference,
};

const actions = {};

const mutations = {
	setAppVersion(state, value) {
		Vue.set(state, "appversion", value);
	},
	setHeadersPreference(state, value) {
		localStorage.setItem("headerspreference", JSON.stringify(value));
		state.headerspreference = value;
	},
};

export default {
	state,
	getters,
	actions,
	mutations,
};
